import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M3.125 13.2812C3.25 12.8438 3.5 12.4375 3.8125 12.125L13.3125 2.625C14.0938 1.84375 15.375 1.84375 16.1562 2.625L17.375 3.84375C17.4688 3.9375 17.5625 4.0625 17.625 4.15625C18.1562 4.9375 18.0625 6 17.375 6.6875L7.875 16.1875C7.84375 16.2188 7.78125 16.25 7.75 16.3125C7.4375 16.5625 7.09375 16.75 6.71875 16.875L4.28125 17.5938L2.9375 18C2.6875 18.0625 2.40625 18 2.21875 17.7812C2 17.5938 1.9375 17.3125 2.03125 17.0625L2.40625 15.7188L3.125 13.2812ZM4.5625 13.7188L4.34375 14.4375L3.84375 16.1562L5.5625 15.6562L6.28125 15.4375C6.5 15.375 6.65625 15.2812 6.8125 15.125L13.9688 7.96875L12.0312 6.03125L4.875 13.1875C4.84375 13.1875 4.84375 13.2188 4.8125 13.25C4.6875 13.375 4.625 13.5312 4.5625 13.7188Z"
	})
});
const ForwardRef = forwardRef(SvgEdit);
export default ForwardRef;
